/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {SetOnboardingContextRequest} from '@cash-web/protos/squareup/franklin/app/onboarding_context.pb'
import {SetOnboardingContextResponse} from '@cash-web/protos/squareup/franklin/app/onboarding_context.pb'


export const setOnboardingContext = (request: SetOnboardingContextRequest, options?: CashRequestOptions) => post<SetOnboardingContextRequest, SetOnboardingContextResponse>("/2.0/cash/set-onboarding-context", request, {...options, rejectOnError: true })